var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEtsyLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F45800",
  d: "M15 .5H0v15h15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.636 3.458v4.225s1.489 0 2.286-.06c.626-.11.742-.17.857-.797l.23-.918h.682l-.115 2.006.06 2.055H8.95l-.17-.803c-.17-.571-.4-.687-.857-.742-.571-.06-2.286-.06-2.286-.06v3.544c0 .681.346.972 1.143.972H9.18c.742 0 1.483-.06 1.945-1.143l.621-1.373h.577c-.06.285-.346 2.802-.4 3.368 0 0-2.171-.055-3.083-.055H4.724l-2.456.055v-.621l.797-.176c.577-.115.747-.286.747-.742 0 0 .06-1.544.06-4.116 0-2.565-.06-4.11-.06-4.11 0-.51-.17-.626-.747-.742l-.797-.168V2.43l2.401.05H9.24c.913 0 2.45-.165 2.45-.165s-.054.967-.115 3.252h-.626l-.231-.802c-.225-1.028-.566-1.539-1.198-1.539H5.927c-.29 0-.29.056-.29.232"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h15v15H0z"
})))));
export default SvgEtsyLogo;